import { Component, computed, input } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { SidePanelService } from '@services/side-panel.service';

export const developerToolsSidePanelParams = {
  id: 'developer-tools-side-panel',
  title: 'Herramientas para desarrolladores',
};

export interface DeveloperToolsSidePanelInputs extends Record<string, unknown> {
  entity: unknown;
}

export type DeveloperToolsSidePanelOutputs = Record<string, never>;

type JsonTokenType = 'boolean' | 'key' | 'null' | 'number' | 'punctuation' | 'string' | 'whitespace';

interface JsonToken {
  text: string;
  type: JsonTokenType;
}

interface JsonLine {
  number: number;
  tokens: JsonToken[];
}

@Component({
  imports: [
    ButtonComponent,
  ],
  selector: 'app-developer-tools',
  styleUrls: ['./developer-tools.component.scss'],
  templateUrl: './developer-tools.component.html',
})
export class DeveloperToolsComponent {
  protected entity = input.required<Record<string, unknown>>();
  protected jsonLines = computed(() => this.getJsonLines(this.entity()));

  constructor(
    private sidePanelService: SidePanelService,
  ) {}

  private getJsonLines(entity: Record<string, unknown>): JsonLine[] {
    const prettyJson = JSON.stringify(entity, null, 4);
    if (!prettyJson) {
      return [{ number: 1, tokens: [{ text: 'null', type: 'null' }] }];
    }
    return prettyJson.split('\n').map((line, index) => ({
      number: index + 1,
      tokens: this.tokenizeLine(line),
    }));
  }

  private tokenizeLine(line: string): JsonToken[] {
    const tokenRegex = /("(?:\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"\s*:|"(?:\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"|\btrue\b|\bfalse\b|\bnull\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|\{|\}|\[|\]|,|:)/g;
    const tokens: JsonToken[] = [];
    let currentIndex = 0;
    let match = tokenRegex.exec(line);
    while (match) {
      if (match.index > currentIndex) {
        tokens.push({ text: line.slice(currentIndex, match.index), type: 'whitespace' });
      }
      const value = match[0];
      if (value.startsWith('"') && value.endsWith(':')) {
        tokens.push({ text: value.slice(0, -1), type: 'key' });
        tokens.push({ text: ':', type: 'punctuation' });
      } else if (value.startsWith('"')) {
        tokens.push({ text: value, type: 'string' });
      } else if (value === 'true' || value === 'false') {
        tokens.push({ text: value, type: 'boolean' });
      } else if (value === 'null') {
        tokens.push({ text: value, type: 'null' });
      } else if (/^-?\d/.test(value)) {
        tokens.push({ text: value, type: 'number' });
      } else {
        tokens.push({ text: value, type: 'punctuation' });
      }
      currentIndex = match.index + value.length;
      match = tokenRegex.exec(line);
    }
    if (currentIndex < line.length) {
      tokens.push({ text: line.slice(currentIndex), type: 'whitespace' });
    }
    return tokens;
  }

  protected close(): void {
    this.sidePanelService.close(developerToolsSidePanelParams.id);
  }
}
